import { createContext } from "react";
import { makeRect } from "../utils/dom/rect.js";
const IndexListContext = createContext({
    activeIndex: -1,
    activeArrayedIndex: -1,
    inner: false,
    getListRect: () => makeRect(0, 0),
    getAnchorRects: () => [],
    getFirstAnchorTop: () => 0,
});
export default IndexListContext;
